import { render } from "./coupons.vue?vue&type=template&id=8376eb6a"
import script from "./coupons.vue?vue&type=script&lang=js"
export * from "./coupons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__